import { Component, input } from '@angular/core';
import { MenuItem } from 'primeng/api';
import { AvatarModule } from 'primeng/avatar';
import { MenuModule } from 'primeng/menu';
import { RippleModule } from 'primeng/ripple';

@Component({
  selector: 'lib-account-menu',
  imports: [AvatarModule, MenuModule, RippleModule],
  templateUrl: './account-menu.html',
})
export class AccountMenu {
  menuItems = input<MenuItem[]>([]);
  userImage = input<string>('');
  userName = input.required<string>();
  userRole = input.required<string>();
}
